import React, { useEffect, useRef } from "react";

export default function SocialBarAd({ isActive }) {
  const scriptRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!isActive) {
      if (scriptRef.current) {
        scriptRef.current.remove();
        scriptRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      return;
    }

    if (!scriptRef.current) {
      const script = document.createElement("script");
      script.src = "//spendharassingwarmly.com/31/cc/fe/31ccfe46c05337d422c869d78e9c5a3c.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
      scriptRef.current = script;

      // Calcul d'un délai aléatoire entre 35s et 75s
      const randomDelay = 35000 + Math.random() * (75000 - 35000);

      // Décharger le script après ce délai aléatoire
      timeoutRef.current = setTimeout(() => {
        if (scriptRef.current) {
          scriptRef.current.remove();
          scriptRef.current = null;
        }
      }, randomDelay);
    }

    return () => {
      if (scriptRef.current) {
        scriptRef.current.remove();
        scriptRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [isActive]);

  return null;
}
